import { db, storage } from '../firebase';
// Correcting imports for firestore
import {
  collection as fsCollection,
  doc as fsDoc,
  getDoc as fsGetDoc,
  getDocs as fsGetDocs,
  setDoc as fsSetDoc,
  updateDoc as fsUpdateDoc,
  deleteDoc as fsDeleteDoc,
  query as fsQuery,
  where as fsWhere,
  orderBy as fsOrderBy,
  onSnapshot as fsOnSnapshot,
  serverTimestamp
} from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

// Generic Data Fetching (Live Subscription)
export const subscribeToDoc = (collectionName: string, docId: string, callback: (data: any) => void) => {
  const docRef = fsDoc(db, collectionName, docId);
  return fsOnSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      callback({ id: snap.id, ...snap.data() });
    } else {
      callback(null);
    }
  });
};

export const subscribeToCollection = (collectionName: string, callback: (data: any[]) => void) => {
  const colRef = fsCollection(db, collectionName);
  return fsOnSnapshot(colRef, (snap) => {
    const items = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    callback(items);
  });
};

// Generic CRUD
export const getDocument = async (collectionName: string, docId: string) => {
  const docRef = fsDoc(db, collectionName, docId);
  const snap = await fsGetDoc(docRef);
  if (snap.exists()) return { id: snap.id, ...snap.data() };
  return null;
};

export const setDocument = async (collectionName: string, docId: string, data: any) => {
  const docRef = fsDoc(db, collectionName, docId);
  await fsSetDoc(docRef, { ...data, updatedAt: serverTimestamp() }, { merge: true });
};

export const createDocument = async (collectionName: string, data: any) => {
  const colRef = fsCollection(db, collectionName);
  const newDocRef = fsDoc(colRef);
  await fsSetDoc(newDocRef, { ...data, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
  return newDocRef.id;
};

export const deleteDocument = async (collectionName: string, docId: string) => {
  const docRef = fsDoc(db, collectionName, docId);
  await fsDeleteDoc(docRef);
};

// Storage Helpers
export const uploadFile = async (file: File, path: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, `${path}/${Date.now()}_${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on('state_changed', 
      (snapshot) => {
        // progress can be tracked here if needed
      }, 
      (error) => reject(error), 
      async () => {
        const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadUrl);
      }
    );
  });
};

export const deleteFile = async (fileUrl: string) => {
  try {
    const fileRef = ref(storage, fileUrl);
    await deleteObject(fileRef);
  } catch (err) {
    console.error("Error deleting file", err);
  }
};
